module.exports = __webpack_public_path__ + "img/CloudComp2.6e8d37d8.jpeg";